function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.6 2.5c-.3 0-.5.2-.5.5s.2.5.5.5h7.9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0 5c-.3 0-.5.2-.5.5s.2.5.5.5h7.9c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM6.1 13c0-.3.2-.5.5-.5h7.9c.3 0 .5.2.5.5s-.2.5-.5.5H6.6c-.3 0-.5-.2-.5-.5zM1.5 2.5c-.3 0-.5.2-.5.5s.2.5.5.5h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM1 8c0-.3.2-.5.5-.5h2c.3 0 .5.2.5.5s-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5zm.5 4.5c-.3 0-.5.2-.5.5s.2.5.5.5h2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z",
  fillRule: "evenodd"
})));